import classNames from 'classnames';
import type { CSSProperties } from 'react';
import { LayoutStack } from '../layouts';
import { WaveyWrapperProps } from './types';
import styles from './WaveyWrapper.module.css';
function WaveyWrapper({
  children,
  bright = false,
  topOnly,
  bottomOnly,
  className,
  space = 'none'
}: WaveyWrapperProps) {
  return <LayoutStack space="none" className={classNames(styles.outerContainer, {
    [styles.bright!]: bright,
    [styles.dark!]: !bright,
    [styles.bottomOnly!]: bottomOnly,
    [styles.topOnly!]: topOnly
  })} style={{
    '--space': `var(--betterplace-spacing-${space})`
  } as CSSProperties}>
      <LayoutStack space="400" className={classNames(styles.contentContainer, className)}>
        {children}
      </LayoutStack>
    </LayoutStack>;
}
export default WaveyWrapper;